import Typograf from 'typograf';

const typograf = new Typograf({ locale: ['ru', 'en-US'] });

// Cписок правил: https://github.com/typograf/typograf/blob/dev/docs/RULES.ru.md
typograf.disableRule('*');
typograf.enableRule('common/punctuation/quote');
typograf.enableRule('ru/nbsp/*');
typograf.enableRule('common/nbsp/*');
typograf.enableRule('common/space/trimLeft');
typograf.enableRule('common/space/trimRight');
typograf.enableRule('common/space/delRepeatSpace');
typograf.enableRule('en-US/dash/main');
typograf.enableRule('ru/dash/main');
typograf.enableRule('ru/dash/directSpeech');

export default typograf;
